import { useMemo } from "react";
import ProfileSheet from "..";
import { useVisible } from "../../../../utils/hooks/useVisible"

export const useProfileSheet = () => {
    const { visible, open, close, selected } = useVisible();

    const sheet = useMemo(() => {
        return (
            <ProfileSheet
                isOpen={visible}
                close={close}
                id={selected?.id || selected}
            />
        )
    }, [visible, close, selected]);

    return { open, sheet };
}
